import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Title3 from 'base/components/Title3/index';
import { closeModal } from 'modal/store/actions';
import Button from 'base/components/Button/index';
import Col from 'base/components/Col/index';
import Row from 'base/components/Row/index';
import { deleteDefaultDashboard } from 'dashboard/store/defaultDashboards/actions';
import { getActiveDefaultDashboard } from 'dashboard/store/defaultDashboards/selectors';

const DashboardDeleteModal = ({
  name, closeModal, dashboard, deleteDefaultDashboard,
}) => (
  <>
    <MainTitle withSpaceBelow>Delete default dashboard</MainTitle>

    <FieldWrapper>
        Do you really want to delete
      <Title3>{dashboard && dashboard.name}</Title3>
    </FieldWrapper>

    <Row>
      <Col>
        <Button isFullWidth variant="secondary" onClick={() => closeModal(name)}>No, cancel</Button>
      </Col>
      <Col>
        <Button
          isFullWidth
          variant="primary"
          onClick={() => { closeModal(name); deleteDefaultDashboard(dashboard); }}
        >
            Yes, delete
        </Button>
      </Col>
    </Row>
  </>
);
DashboardDeleteModal.propTypes = {
  name: PropTypes.string.isRequired,
  dashboard: PropTypes.object.isRequired, // eslint-disable-line
  closeModal: PropTypes.func.isRequired,
  deleteDefaultDashboard: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dashboard: getActiveDefaultDashboard(state),
});

const mapDispatchToProps = {
  deleteDefaultDashboard,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardDeleteModal);
